module.exports = __webpack_public_path__ + "img/2.75f3da60.jpg";